import {
  Box,
  Button,
  FormControlLabel,
  Grid,
  MenuItem,
  Pagination,
  Paper,
  Select,
  Switch,
  Typography,
} from '@mui/material';
import React from 'react';
import { useState } from 'react';
import { COLORS } from '../../../utils/colors';
import { Add, BorderColor, Edit, Tune } from '@mui/icons-material';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import CustomLoadingBar from '../../../components/CustomLoadingBar/CustomLoadingBar';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useHomeOwnerPageStyles } from './styles/intex';
import HomeOwnerFilterModal from '../HomeOwnerFilterModal';

const headings = ['HOME OWNER', 'EMAIL', 'LOCATION', 'PURCHASED', 'YEAR BUILT'];
const items = [
  {
    homeOwner: 'John Doe',
    email: 'johndoe@example.com',
    location: 'New York, NY',
    yearBuilt: 1998,
    yearPurchased: 2010,
    sessionDateTime: '2024-11-01T10:00:00Z', // Future session
  },
  {
    homeOwner: 'Jane Smith',
    email: 'janesmith@example.com',
    location: 'Los Angeles, CA',
    yearBuilt: 2005,
    yearPurchased: 2022,
    sessionDateTime: '2024-10-25T14:30:00Z', // Past session
  },
  {
    homeOwner: 'Robert Brown',
    email: 'robertbrown@example.com',
    location: 'Chicago, IL',
    yearBuilt: 1985,
    yearPurchased: 1990,
    sessionDateTime: '2024-11-03T11:15:00Z', // Future session
  },
  {
    homeOwner: 'Lisa Green',
    email: 'lisagreen@example.com',
    location: 'Houston, TX',
    yearBuilt: 2010,
    yearPurchased: 2015,
    sessionDateTime: '2024-11-05T09:45:00Z', // Future session
  },
  {
    homeOwner: 'Michael Johnson',
    email: 'michaeljohnson@example.com',
    location: 'Miami, FL',
    yearBuilt: 1993,
    yearPurchased: 2000,
    sessionDateTime: '2024-10-30T16:00:00Z', // Past session
  },
  {
    homeOwner: 'Emily White',
    email: 'emilywhite@example.com',
    location: 'Phoenix, AZ',
    yearBuilt: 2015,
    yearPurchased: 2018,
    sessionDateTime: '2024-09-15T13:00:00Z', // Past session
  },
  {
    homeOwner: 'David Black',
    email: 'davidblack@example.com',
    location: 'Seattle, WA',
    yearBuilt: 2000,
    yearPurchased: 2021,
    sessionDateTime: '2024-12-01T12:00:00Z', // Future session
  },
];

const HomeOwners = () => {
  const [selectedReport, setSelectedReport] = useState();
  const [showUpcomimng, setShowUpcoming] = useState(false);
  const [progress, setProgress] = useState(54);
  const [currentPage, setCurrentPage] = useState(1);
  const [filtersModal, setFiltersModal] = useState(false);
  const itemsPerPage = 5;

  const [data, setData] = useState(items);
  const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });

  const styles = useHomeOwnerPageStyles();

  const handleSort = (key: any) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });

    const sortedItems = [...items].sort((a: any, b: any) => {
      if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
      return 0;
    });
    setData(sortedItems);
  };

  const filteredData = showUpcomimng
    ? data.filter(
        (item) => new Date(item.sessionDateTime).getTime() > Date.now(),
      )
    : data.filter(
        (item) => new Date(item.sessionDateTime).getTime() < Date.now(),
      );

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedData = filteredData.slice(startIndex, endIndex);

  const pageCount = Math.ceil(filteredData.length / itemsPerPage);

  return (
    <>
      <Box width={'100%'} display={'flex'} justifyContent={'center'}>
        <Box sx={styles.container}>
          <Box sx={styles.header}>
            <Box>
              <Typography fontSize={'1.1rem'} fontWeight={500} width={'100%'}>
                HomeOwners
              </Typography>
            </Box>
            <Box display={'flex'} width={'42%'} alignItems={'center'}>
              <FormControlLabel
                label="Show only upcoming sessions"
                control={
                  <Switch
                    sx={{ fontSize: '13px' }}
                    checked={showUpcomimng}
                    onChange={() => setShowUpcoming(!showUpcomimng)}
                  />
                }
              />
              <Button
                disabled={true}
                sx={{
                  borderColor: COLORS.MEDIUM_GRAY,
                  borderRadius: '16px',
                  textTransform: 'none',
                }}
                variant="outlined">
                <Add /> Add Homeowner
              </Button>
              <Tune
                onClick={() => setFiltersModal(true)}
                sx={{
                  color: COLORS.DARK_GREY,
                  cursor: 'pointer',
                  marginLeft: '1rem',
                  fontSize: '1.7rem',
                }}
              />
            </Box>
          </Box>
          <Box sx={styles.headings}>
            <Grid container>
              {headings.map((heading, index) => {
                const key = heading.replace(' ', '').toLowerCase();
                return (
                  <Grid
                    xs={2}
                    key={index}
                    onClick={() => handleSort(key)}
                    style={{ cursor: 'pointer' }}>
                    <Typography
                      display={'flex'}
                      justifyContent={'center'}
                      alignItems={'center'}>
                      {heading}{' '}
                      {heading !== 'ACTION ITEMS' && (
                        <>
                          <UnfoldMoreIcon fontSize="small" />
                        </>
                      )}
                    </Typography>
                  </Grid>
                );
              })}
            </Grid>
          </Box>

          <Box display={'block'} marginTop={'0'}>
            {paginatedData.map((item, index) => (
              <Grid
                sx={{
                  borderBottom: '1px solid #e9e9e9',
                  alignItems: 'center',
                }}
                container
                key={index}>
                <Grid sx={styles.rowItem} item xs={2}>
                  <Typography align="center">{item.homeOwner}</Typography>
                </Grid>
                <Grid sx={styles.rowItem} item xs={2}>
                  <Typography align="center">{item.email}</Typography>
                </Grid>
                <Grid sx={styles.rowItem} item xs={2}>
                  <Typography align="center">{item.location}</Typography>
                </Grid>
                <Grid sx={styles.rowItem} item xs={2}>
                  <Typography align="center">{item.yearPurchased}</Typography>
                </Grid>
                <Grid sx={styles.rowItem} item xs={2}>
                  <Typography align="center">{item.yearBuilt}</Typography>
                </Grid>
                <Grid xs={2} style={{ cursor: 'pointer' }}>
                  <Typography align="center">
                    <RemoveRedEyeOutlinedIcon fontSize="large" />
                  </Typography>
                </Grid>
              </Grid>
            ))}
          </Box>
          <Box display={'flex'} justifyContent={'space-between'}>
            <Box
              display="flex"
              justifyContent="flex-start"
              alignItems="center"
              mt={4}
              ml={2}>
              <Typography>
                Showing {startIndex + 1}-{endIndex} of {filteredData.length}
              </Typography>
            </Box>
            <Box
              display="flex"
              justifyContent="flex-end"
              alignItems={'flex-end'}>
              <Pagination
                count={pageCount}
                page={currentPage}
                onChange={(event, value) => setCurrentPage(value)}
              />
            </Box>
          </Box>
        </Box>
      </Box>
      <HomeOwnerFilterModal
        open={filtersModal}
        onClose={() => setFiltersModal(false)}
      />
    </>
  );
};

export default HomeOwners;
